/**
 * ログ出力APIを呼ぶための共通処理です。
 */
export default class Logger {

  /**
   * コンストラクタ
   * @param {string} eventName ログ出力時の処理名を表すイベント名
   */
  constructor(eventName) {
    /** @type {Date} 開始時刻 */
    this.startTime = new Date();
    /** @type {string} ログ出力時の処理名を表すイベント名 */
    this.eventName = eventName;
  }

  /**
   * ログレベル「info」のログ出力をします。
   * @param {string} message 出力メッセージ
   * @param {object|any[]} [param] リクエストパラメータやレスポンスパラメータ
   */
  info(message, param) {
    this.output('info', message, param);
  }

  /**
   * ログレベル「debug」のログ出力します。
   * @param {string} message 出力メッセージ
   * @param {object|any[]} [param] リクエストパラメータやレスポンスパラメータ
   */
  debug(message, param) {
    this.output('debug', message, param);
  }

  /**
   * ログレベル「error」のログ出
   * @param {string} message 出力メッセージ
   * @param {object|any[]} [param] リクエストパラメータやレスポンスパラメータ
   */
  error(message, param) {
    this.output('error', message, param);
  }

  /**
   * ログ出力を行います。
   * @param {'debug' | 'info' | 'warn' | 'error'} logLevel ログレベル
   * @param {string} message 出力メッセージ
   * @param {object|any[]} [param] リクエストパラメータやレスポンスパラメータ
   */
  output(logLevel, message, param) {
    if (!import.meta.env.MODE.endsWith('production')) {
      const now = new Date();
      const elapsed_time = (now.getTime() - this.startTime.getTime()) / 1000;
      /** @type {Function} */
      const logHandler = console[logLevel] ?? console.log;
      const logMessage = `${now.toLocaleTimeString()}.${now.getMilliseconds().toString().padStart(3, '0')} ${this.eventName}：${message} [${elapsed_time}sec]`;
      param ? logHandler(logMessage, param) : logHandler(logMessage);
    }
  }
}
